export default __webpack_public_path__ + "static/media/fromhome1.04caf28f.jpeg";